import { inject } from '@angular/core';
import { MultiTenancyService } from '@core/multi-tenancy/services/multi-tenancy.service';
import { of, switchMap } from 'rxjs';
import { CanActivateFn, Router } from '@angular/router';

export const validTenantGuard: CanActivateFn = () => {
    const multiTenancyService = inject(MultiTenancyService);
    const router = inject(Router);
    return multiTenancyService.checkTenantValidity().pipe(
        switchMap((isValid) => {
            if (isValid) {
                return of(true);
            } else {
                return router.navigate(['fallback', 'invalid-tenant']);
            }
        }),
    );
};
